// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__1meX1","Open":"SideDrawer_Open__2ZFHj","Closed":"SideDrawer_Closed__1b_87","Logo":"SideDrawer_Logo__1kAhp"};